import { ROUTE_NAMES } from './routeNames.const'

export const routePatrimonyDevelopment = {
  path: '/patrimony-development/:pageId?',
  name: ROUTE_NAMES.dmp,
  component: () =>
    import(
      /* webpackChunkName: "PatrimonyDevelopmentCircuit" */ 'src/pages/PatrimonyDevelopment/patrimony-development.vue'
    ),
}
